const getValidationErrors = (service, t) => {
  const errors = {};

  if (!service.name?.trim()) {
    errors.name = t("title_required");
  }

  if (!service.serviceTypeId) {
    errors.serviceTypeId = t("service_type_required");
  }

  if (!service.logoImage && !service.coverImage) {
    errors.images = t("upload_images");
  }

  const subServiceErrors =
    service?.subServices?.map((sub) => {
      if (!sub.name?.trim()) {
        return { name: t("subService_title_required") };
      }
      return null;
    }) || [];

  // Add only if any subService has error
  if (subServiceErrors.some((err) => err !== null)) {
    errors.subServiceErrors = subServiceErrors;
  }

  return errors;
};


module.exports = {
  getValidationErrors
};